import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react'

import { breakpoints as Breakpoints, CarouselContainer } from 'ui/acro'
import { useSwiper } from 'hooks'
import CarouselNextButton from './CarouselNextButton'
import CarouselPrevButton from './CarouselPrevButton'
import usePlaylistDrawer from 'hooks/usePlaylistDrawer'
import useAddToCalendar from 'hooks/useAddToCalendar'
import { useUserContext } from 'context'
const Carousel = ({
  data,
  slug,
  carouselTitle,
  slidesPerView = 3,
  card,
  breakpoints = {},
  location,
  eventName,
  isStructuredSeriesCarousel = false,
  fetchNextData = () => {},
  pageNumber,
  totalCards,
  section,
  handleEventAddToCalendarClick
}) => {
  const { getSwiperProps, goPrev, goNext, isBeginning, isEnd } = useSwiper()
  const [cards, setCards] = useState(data)
  const [loadedLength, setLoadedLength] = useState(0)
  const cardLength = cards?.length || 0
  useEffect(() => setCards(data), [data])
  const { user } = useUserContext() || {}
  const { handleAddToCalendarClick, AddToCalendarDialog } = useAddToCalendar()

  const updatePlaylistList = (updatedPlaylistIds) => {
    setCards((prev) =>
      prev.map((card) =>
        card?.item
          ? card.item.id === selectedCardData?.id
            ? {
                ...card,
                item: { ...card.item, playlistIds: updatedPlaylistIds }
              }
            : card
          : card.id === selectedCardData?.id
          ? { ...card, playlistIds: updatedPlaylistIds }
          : card
      )
    )
    // setDrawerOpen(false);
  }

  const { handlePlaylistIconClick, AddToPlaylistDrawer, selectedCardData } =
    usePlaylistDrawer(updatePlaylistList)

  const handleNextClick = () => {
    if (
      totalCards &&
      cardLength < parseInt(totalCards) &&
      loadedLength < cardLength &&
      isEnd
    ) {
      setLoadedLength(cardLength)
      fetchNextData({
        section: section,
        pageNumber: pageNumber + 1,
        callBack: goNext
      })
    } else {
      goNext()
    }
  }

  const handleEventCancelled = (cancelledId) => {
    setCards((prev) =>
      (prev || []).filter((it) => (it?.item?.id ?? it?.id) !== cancelledId)
    )
  }

  const handleSlideChange = (swiper) => {
    if (
      totalCards &&
      cardLength < parseInt(totalCards) &&
      loadedLength < cardLength &&
      swiper.activeIndex >= cardLength - 4
    ) {
      setLoadedLength(cardLength)
      fetchNextData({
        section: section,
        pageNumber: pageNumber + 1
      })
    }
  }
  return (
    <CarouselContainer carouselTitle={carouselTitle}>
      <Swiper
        {...getSwiperProps({
          lazy: true,
          slidesPerGroup: 1,
          spaceBetween: 20,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          watchOverflow: true,
          freeMode: true,
          freeModeSticky: true,
          slidesPerView,
          breakpoints: {
            [Breakpoints[0]]: {
              spaceBetween: 20
            },
            [Breakpoints[1]]: {
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0
            },
            [Breakpoints[2]]: {
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0
            },
            ...breakpoints
          }
        })}
        onSlideChange={handleSlideChange}
      >
        {cards &&
          cards.map((item, index) => (
            <SwiperSlide
              tag={card}
              key={index}
              carouselItem={true}
              position={index + 1}
              htmlId={carouselTitle + (index + 1)} // using htmlId because some cards already have an ID coming from the API - this is purely for heap tracking
              eventName={eventName}
              location={location}
              {...item}
              membershipTier={user?.membershipTier}
              onPlaylistIconClick={() =>
                handlePlaylistIconClick(item?.item ?? item)
              }
              showScheduleButton={
                Boolean(item?.unlocked ?? item?.item?.unlocked) &&
                isStructuredSeriesCarousel
              }
              handleAddToCalendarClick={() => {
                handleAddToCalendarClick(item?.item ?? item)
              }}
              handleEventAddToCalendarClick={() => {
                handleEventAddToCalendarClick(item?.item ?? item)
              }}
              onEventCancelled={handleEventCancelled}
            />
          ))}
      </Swiper>

      <CarouselPrevButton
        handleClick={goPrev}
        disabled={isBeginning}
        display={['none', null, null, 'inherit']}
        id={`home-${slug}-carousel-prev`}
        aria-label='Previous'
      />
      <CarouselNextButton
        handleClick={handleNextClick}
        disabled={
          totalCards ? isEnd && cardLength === parseInt(totalCards) : isEnd
        }
        display={['none', null, null, 'inherit']}
        id={`home-${slug}-carousel-next`}
        aria-label='Next'
      />
      {AddToPlaylistDrawer}
      {AddToCalendarDialog}
    </CarouselContainer>
  )
}

Carousel.propTypes = {
  layout: PropTypes.string,
  carouselTitle: PropTypes.string,
  slug: PropTypes.string,
  card: PropTypes.object
}

export default Carousel
